<script setup lang="ts">
import {
  PaginationEllipsis,
  PaginationFirst,
  PaginationLast,
  PaginationList,
  PaginationListItem,
  PaginationNext,
  PaginationPrev,
  PaginationRoot,
} from 'reka-ui';

const props = defineProps<{
  total: number;
  itemsPerPage: number;
  siblingCount: number;
  pageName: string;
  theme: 'admin' | 'client';
}>();

const pageNumber = useState<number>(props.pageName);
</script>

<template>
  <PaginationRoot
    v-if="props.total > props.itemsPerPage"
    v-model:page="pageNumber"
    :total="props.total"
    :sibling-count="props.siblingCount"
    :items-per-page="props.itemsPerPage"
    :class="[$style[theme]]"
    show-edges
  >
    <PaginationList v-slot="{ items }" :class="$style.PaginationList">
      <PaginationFirst :class="$style.button">
        <Icon name="ic:baseline-keyboard-double-arrow-left" />
      </PaginationFirst>
      <PaginationPrev :style="{ marginRight: 16 }" :class="$style.button">
        <Icon name="ic:baseline-chevron-left" />
      </PaginationPrev>
      <template v-for="(page, index) in items">
        <PaginationListItem
          v-if="page.type === 'page'"
          :key="index"
          :class="$style.button"
          :value="page.value"
        >
          {{ page.value }}
        </PaginationListItem>
        <PaginationEllipsis
          v-else
          :key="page.type"
          :index="index"
          :class="$style.PaginationEllipsis"
        >
          &#8230;
        </PaginationEllipsis>
      </template>
      <PaginationNext :style="{ marginLeft: 16 }" :class="$style.button">
        <Icon name="ic:baseline-chevron-right" />
      </PaginationNext>
      <PaginationLast :class="$style.button">
        <Icon name="ic:baseline-keyboard-double-arrow-right" />
      </PaginationLast>
    </PaginationList>
  </PaginationRoot>
</template>
<style lang="scss" module>
button {
  all: unset;
}

.button {
  text-align: center;
  font-size: 15px;
  line-height: 1;
  align-items: center;
  justify-content: center;
  height: 2.25rem;
  width: 2.25rem;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.button:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.button[data-selected] {
  background-color: var(--color-gray-bg);
  color: var(--color-black-1);
}

.PaginationEllipsis {
  display: flex;
  height: 2.25rem;
  width: 2.25rem;
  align-items: center;
  justify-content: center;
}

.PaginationList {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}

.client {
  .button[data-selected] {
    background-color: var(--color-gray-bg);
    color: var(--color-black-1);
  }

  .PaginationList {
    color: var(--color-black-1);
    padding: var(--space-2-5x);
  }
}

.admin {
  .button[data-selected] {
    background-color: rgb(0 0 0);
    color: #fff;
    border-radius: 0.25rem;
  }

  .PaginationList {
    color: rgb(0 0 0);
  }
}
</style>
